import * as React from 'react';
import { useEffect } from 'react';

import Banner, { BannerData } from '@/components/elements/Banner';
import useScript, { Status } from '@/hooks/useScript';
import { BannerAreaLabel } from '@/lib/dmm/trackingTag/type';

interface TopBannerListProps {
  bannerList: BannerData[];
  bannerArea: BannerAreaLabel;
}

const TopBannerList: React.FC<TopBannerListProps> = ({
  bannerList,
  bannerArea,
}) => {
  const gtaScript = useScript('/customGtaScript.js');

  /** クリックイベント */
  const clickEvent = (alt?: string) => {
    if (
      alt &&
      alt === 'DMMプレミアム新規登録30日間無料' &&
      gtaScript === Status.Ready
    ) {
      window.sendPremiumBannerClickEvent(bannerArea);
    }
  };

  useEffect(() => {
    if (gtaScript === Status.Ready) {
      bannerList.forEach(b => {
        if (b.alt && b.alt === 'DMMプレミアム新規登録30日間無料') {
          window.sendPremiumBannerViewEvent(bannerArea);
        }
      });
    }
  }, [gtaScript]);

  return (
    <>
      {bannerList.map((banner, i) => (
        <li
          key={`${banner.link}${i}`}
          onClick={() => {
            clickEvent(banner.alt);
          }}
        >
          <Banner {...banner} />
        </li>
      ))}
    </>
  );
};

export default TopBannerList;
